import axios from "axios";
import {
  API_BASE_URL,
  AUTH_BASE_URL,
  BASE_LOGIN_REDIRECT_URL,
} from "../../constants/api.constants";

const instance = axios.create({
  withCredentials: true,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Credentials": "true",
  },
});

instance.defaults.headers.common[
  "Authorization"
] = `Bearer ${localStorage.getItem("token")}`;
instance.defaults.headers.post["Content-Type"] = "application/json";
instance.defaults.baseURL = API_BASE_URL;

instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const originalRequest = error.config;
    const userEmail = localStorage.getItem("email");

    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403) &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      const refreshToken = window.localStorage.getItem("refresh_token");

      return axios
        .post(`${AUTH_BASE_URL}/token/auth`, {
          email: userEmail,
          grant_type: "refresh_token",
          refresh_token: refreshToken,
        })
        .then((token) => {
          if (token.data.result.code !== "999") {
            localStorage.removeItem("token");
            localStorage.removeItem("refresh_token");
            localStorage.removeItem("email");
            localStorage.removeItem("role");
            localStorage.removeItem("schoolName");
            localStorage.removeItem("school");
            localStorage.removeItem("aplSupervisorHasRegistered");
            localStorage.removeItem("help");
            localStorage.removeItem("tmpEmail");
            localStorage.removeItem("tmpRole");
            localStorage.removeItem("showResult");
            window.location.replace(`${BASE_LOGIN_REDIRECT_URL}/`);
            window.location.href = "/";
          } else {
            var res = JSON.parse(token.data.result.data);
            localStorage.setItem("email", token.data.result.email);
            localStorage.setItem("token", res.access_token);
            localStorage.setItem("refresh_token", res.refresh_token);

            instance.defaults.headers.common["Authorization"] =
              "Bearer " + res.access_token;
            originalRequest.headers["Authorization"] =
              "Bearer " + res.access_token;
          }

          return instance(originalRequest);
        });
    }

    return Promise.reject(error);
  }
);

export default instance;
